import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBagIcon } from 'lucide-react';
const buyers = [{
  name: 'María G.',
  city: 'Madrid'
}, {
  name: 'Carolina P.',
  city: 'Buenos Aires'
}, {
  name: 'Lucía R.',
  city: 'Ciudad de México'
}, {
  name: 'Ana M.',
  city: 'Bogotá'
}, {
  name: 'Valentina S.',
  city: 'Lima'
}, {
  name: 'Sofía L.',
  city: 'Barcelona'
}, {
  name: 'Camila D.',
  city: 'Santiago'
}, {
  name: 'Isabella F.',
  city: 'Medellín'
}, {
  name: 'Daniela H.',
  city: 'Monterrey'
}, {
  name: 'Paula T.',
  city: 'Quito'
}, {
  name: 'Fernanda V.',
  city: 'Sevilla'
}, {
  name: 'Gabriela N.',
  city: 'Guadalajara'
}, {
  name: 'Andrea C.',
  city: 'Córdoba'
}, {
  name: 'Laura B.',
  city: 'Valencia'
}, {
  name: 'Natalia K.',
  city: 'Santo Domingo'
}];
function getRandomMinutes() {
  return Math.floor(Math.random() * 12) + 1;
}
export function PurchasePopup() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [minutes, setMinutes] = useState(getRandomMinutes());
  useEffect(() => {
    // Initial delay before first popup
    const initialDelay = setTimeout(() => {
      setVisible(true);
    }, 5000);
    return () => clearTimeout(initialDelay);
  }, []);
  useEffect(() => {
    if (!visible) return;
    // Hide after 4 seconds
    const hideTimer = setTimeout(() => {
      setVisible(false);
    }, 4000);
    // Show next one after hiding
    const nextTimer = setTimeout(() => {
      setCurrentIndex(prev => (prev + 1) % buyers.length);
      setMinutes(getRandomMinutes());
      setVisible(true);
    }, 12000 + Math.random() * 8000); // Random interval between 12-20 seconds
    return () => {
      clearTimeout(hideTimer);
      clearTimeout(nextTimer);
    };
  }, [visible, currentIndex]);
  const buyer = buyers[currentIndex];
  return <div className="fixed bottom-4 left-4 z-50 pointer-events-none" data-id="element-153">
      <AnimatePresence data-id="element-154">
        {visible && <motion.div initial={{
        opacity: 0,
        y: 40,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 25
      }} className="pointer-events-auto bg-white rounded-2xl shadow-2xl shadow-dark/10 border border-gray-100 px-4 py-3 flex items-center gap-3 max-w-[320px]" data-id="element-155">
            <div className="bg-mint/15 p-2.5 rounded-full shrink-0" data-id="element-156">
              <ShoppingBagIcon className="w-5 h-5 text-mint" data-id="element-157" />
            </div>
            <div className="min-w-0" data-id="element-158">
              <p className="text-dark text-sm font-bold leading-tight truncate" data-id="element-159">
                {buyer.name}
              </p>
              <p className="text-muted text-xs leading-tight mt-0.5" data-id="element-160">
                Compró el Kit desde {buyer.city}
              </p>
              <p className="text-rose text-[11px] font-medium mt-0.5" data-id="element-161">
                hace {minutes} {minutes === 1 ? 'minuto' : 'minutos'}
              </p>
            </div>
            <div className="w-2 h-2 bg-mint rounded-full shrink-0 animate-pulse" data-id="element-162" />
          </motion.div>}
      </AnimatePresence>
    </div>;
}